import { jsxs, jsx } from 'react/jsx-runtime';
import { Root as Switch$1, SwitchThumb } from '../../vendor/@radix-ui/react-switch/dist/index.mjs';
import * as React from 'react';
import { Label } from './label.js';
import { cn } from '../../lib/utils.js';

const Switch = React.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs(
  Switch$1,
  {
    className: cn(
      "peer inline-flex items-center h-6 w-[42px] shrink-0 cursor-pointer rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:data-[state=checked]:bg-state-disabled-04 disabled:data-[state=unchecked]:bg-state-disabled-02 data-[state=checked]:bg-primary-background-04 data-[state=unchecked]:bg-basic-background-03",
      className
    ),
    ...props,
    ref,
    children: [
      /* @__PURE__ */ jsx(
        SwitchThumb,
        {
          className: cn(
            "pointer-events-none block h-[18px] w-[18px] rounded-full relative top-[0px] mr-[4px] bg-white ring-0 transition-transform data-[state=checked]:translate-x-[20px] data-[state=unchecked]:translate-x-[4px]"
          )
        }
      ),
      children
    ]
  }
));
Switch.displayName = Switch$1.displayName;
const SwitchBoxLabel = ({ children }) => {
  return /* @__PURE__ */ jsx(Label, { className: "flex flex-row items-center justify-between gap-2 min-w-[180px] p-3 rounded-md text-basic-02", children });
};
const SwitchWidthLabel = ({ children }) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "[&>button]:flex [&>button]:items-center [&>button]:gap-1 [&>button]:w-auto [&>button]:h-9 [&>button]:pr-3",
        "[&_span]:transition-left [&_span]:relative [&_span]:w-6 [&_span]:h-6 [&_span[data-state=checked]]:translate-x-[50%] [&_span[data-state=checked]]:left-[50%]",
        "[&_label]:relative [&_label]:left-0 [&_label]:transition-all [&_label]:!leading-5 [&_label]:mt-0.5 [&_label]:body-lg [&_label]:font-weight-medium",
        "[&_span[data-state=checked]+label]:transform-x-[50%] [&_span[data-state=checked]+label]:left-[calc(-50%+7px)] [&_span[data-state=checked]+label]:text-white"
      ),
      children
    }
  );
};

export { Switch, SwitchBoxLabel, SwitchWidthLabel };
